import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { MY_ORDERS_ACTIONS, orderSelectors } from '@usf/ngrx-order';
import { map, switchMap, withLatestFrom } from 'rxjs/operators';
import { myOrdersCallTrace } from './models/my-orders-call.trace';
import { MY_ORDERS_TRACING_ACTIONS } from './my-orders-tracing.actions';
import { myOrdersCallTransformer } from './my-orders-tracing.transformers';
@Injectable({
  providedIn: 'root',
})
export class MyOrdersTracingEffects {
  myOrdersCall$ = createEffect(() =>
    this.actions$.pipe(
      ofType(MY_ORDERS_ACTIONS.getMyOrdersContext),
      withLatestFrom(this.store.select(orderSelectors.selectWatermark())),
      map(([_, watermark]) => {
        const trace = JSON.parse(JSON.stringify(myOrdersCallTrace));
        trace.tracing.data.attributes.watermark = watermark;
        trace.tracing.data.isEndOfTrace = false;
        trace.tracing.data.isStartOfTrace = true;
        trace.tracing.transformFunc = myOrdersCallTransformer;
        return trace;
      }),
      switchMap(tracking => [
        MY_ORDERS_TRACING_ACTIONS.traceMyOrdersContext({ tracking }),
      ]),
    ),
  );

  myOrdersCallSuccess$ = createEffect(() =>
    this.actions$.pipe(
      ofType(MY_ORDERS_ACTIONS.getMyOrdersContextSuccess),
      withLatestFrom(this.store.select(orderSelectors.selectWatermark())),
      map(([_, watermark]) => {
        const trace = JSON.parse(JSON.stringify(myOrdersCallTrace));
        trace.tracing.data.attributes.watermark = watermark;
        trace.tracing.data.isEndOfTrace = true;
        trace.tracing.data.isStartOfTrace = false;
        trace.tracing.transformFunc = myOrdersCallTransformer;
        return trace;
      }),
      switchMap(tracking => [
        MY_ORDERS_TRACING_ACTIONS.traceMyOrdersContextSuccess({ tracking }),
      ]),
    ),
  );

  myOrdersCallFail$ = createEffect(() =>
    this.actions$.pipe(
      ofType(MY_ORDERS_ACTIONS.getMyOrdersContextFail),
      withLatestFrom(this.store.select(orderSelectors.selectWatermark())),
      map(([_, watermark]) => {
        const trace = JSON.parse(JSON.stringify(myOrdersCallTrace));
        trace.tracing.data.attributes.watermark = watermark;
        trace.tracing.data.isEndOfTrace = true;
        trace.tracing.data.isStartOfTrace = false;
        trace.tracing.transformFunc = myOrdersCallTransformer;
        return trace;
      }),
      switchMap(tracking => [
        MY_ORDERS_TRACING_ACTIONS.traceMyOrdersContextFail({ tracking }),
      ]),
    ),
  );
  constructor(private actions$: Actions, private store: Store) {}
}
